export default {
  inject: ['repo'],

  props: {
    ConnectedTagRepo: {
      default() {
        return this.repo.get('connectedTags');
      },
    },
  },
};
